<template>
<div style="width: 100%">
	<v-subheader>Users</v-subheader>
	<v-card style="width: 100%">
		<v-data-table
				:headers="headers"
				:items="usersPayments"
				hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.amount }}</td>
			</template>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { HEADERS_TABLE_USER_REPORTS } from '../../constants'
import { localeHeadersWorkers } from '../../utils/helpers'

export default {
	data: vm => ({
		headers: localeHeadersWorkers(HEADERS_TABLE_USER_REPORTS, vm.$t)
	}),
	computed: {
		usersPayments() {
			return this.$store.state.reports.usersPayments
		}
	}
}
</script>
